import { ApiClient } from "./clients";
import { TicketTemplate, ListService } from "@/types";

export const TicketTemplatesService: ListService<TicketTemplate> = {
  async all(options?: any) {
    const params = options?.last
      ? {
          last: options.last,
        }
      : null;
    return await ApiClient.get<TicketTemplate[]>(
      `/api/v1/ticket_templates/`,
      params
    );
  },
  async load(id: number) {
    return await ApiClient.get<TicketTemplate>(
      `/api/v1/ticket_template/${id}/`
    );
  },
};
